<template>
    <div id="detail">
        <div class="smallContent miscContent">
            <img
                :src="item.thumbnail"
                alt=""
                id="mainImage"
                :class="item.category"
            />

            <div
                id="liveInfos"
                v-if="!item.has_audio && itemIsPast"
                :class="{ mobile: $mq == 'sm' }"
            >
                <div v-html="getDate"></div>
                <div v-html="getTime"></div>
            </div>

            <div id="infos" :class="{ mobile: $mq == 'sm' }">
                <div v-if="item.has_audio && itemIsPast">
                    <img
                        v-if="isPlaying(item.pk, item.type)"
                        @click.stop.prevent="setPause"
                        id="play"
                        :src="
                            playHover
                                ? '/static/new_icons/pause-player_hover.svg'
                                : '/static/icons/pause-player.svg'
                        "
                        class="button"
                        @mouseover="playHover = true"
                        @mouseout="playHover = false"
                    />

                    <img
                        v-else
                        @click.stop.prevent="setPlay"
                        id="play"
                        :src="
                            playHover
                                ? '/static/new_icons/play-player-large_hover.svg'
                                : '/static/icons/play-player-large.svg'
                        "
                        class="button"
                        @mouseover="playHover = true"
                        @mouseout="playHover = false"
                    />
                </div>
                <div id="dates">
                    <template v-if="!itemIsPast">
                        <div v-html="getDate"></div>
                    </template>
                    <div>{{ item.artist }}</div>
                    <div>{{ item.title }}</div>
                    <div
                        id="location"
                        :class="{ desktop: $mq != 'sm', live: !item.has_audio }"
                    >
                        <span v-if="item.has_audio && itemIsPast" id="date">{{
                            getDate
                        }}</span>

                        <span
                            v-if="item.show_location_live && !item.has_audio"
                            class="liveLocation"
                        >
                            Live at {{ item.venue }}, {{ item.city }}
                        </span>
                        <template v-else>
                            <span v-if="item.venue">{{ item.venue }}</span>
                            <span v-if="item.city">{{ item.city }}</span>
                        </template>
                    </div>
                </div>

                <div id="buttons">
                    <span id="addText" v-if="item.has_audio && !inPlaylist">
                        <!-- <span v-show="$mq != 'sm'"> Add to public playlist </span> -->
                        <img
                            :src="
                                addHover
                                    ? '/static/new_icons/add_hover.svg'
                                    : '/static/icons/add.svg'
                            "
                            class="button add"
                            @click.stop.prevent="addToList"
                            id="add"
                            @mouseover="addHover = true"
                            @mouseout="addHover = false"
                        />
                    </span>

                    <template v-if="item.has_audio">
                        <img
                            v-if="!store.authenticated"
                            :src="
                                likeHover
                                    ? '/static/Favorite_Hover.svg'
                                    : '/static/Favorite.svg'
                            "
                            @mouseover="likeHover = true"
                            @mouseout="likeHover = false"
                            class="button add"
                            @click="store.showLikePopup = true"
                        />
                        <img
                            v-else-if="
                                store.likes.some((i) => i == item.pk) ||
                                liked == true
                            "
                            @click="removeLike"
                            src="/static/Favorite_Hover.svg"
                            @mouseout="likeHover = false"
                            class="button add"
                        />
                        <img
                            v-else
                            @click="addLike"
                            :src="
                                likeHover
                                    ? '/static/Favorite_Hover.svg'
                                    : '/static/Favorite.svg'
                            "
                            @mouseover="likeHover = true"
                            @mouseout="likeHover = false"
                            class="button add"
                        />
                    </template>
                </div>
            </div>

            <div class="text" v-html="item.description"></div>

            <div
                v-for="(bio, index) in item.artist_bios"
                :key="index"
                class="text"
                v-html="bio"
            ></div>

            <div id="links" v-if="item.links">
                <!--
            <div v-for="link in item.links.slice().reverse()" class="text">
            -->
                <div v-for="link in item.links" class="text">
                    <a :href="link.url" target="_blank">{{ link.title }}</a>
                    <br />
                </div>
            </div>

            <div id="tags" v-if="item.tags || item.series">
                <template
                    v-for="(s, index) in item.all_series.slice().reverse()"
                >
                    <template v-for="series in item.series">
                        <div v-if="series.slug == s.slug" class="tag">
                            <router-link
                                :to="{ name: 'archive' }"
                                event=""
                                @click.native.prevent="
                                    selectSeries(series.slug)
                                "
                            >
                                Series {{ index + 1 }}
                            </router-link>
                        </div>
                    </template>
                </template>
                <div v-for="tag in item.tags" class="tag">
                    <router-link
                        :to="{ name: 'archive' }"
                        event=""
                        @click.native.prevent="selectTag(tag.name)"
                        v-html="upperFirst(tag.name)"
                    >
                    </router-link>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import { DateTime, Duration } from "luxon";
import Footer from "./Footer.vue";

export default {
    name: "Detail",
    components: {
        Footer,
    },
    data() {
        return {
            item: {
                pk: 0,
                image: "",
                title: "",
                artist: "",
                has_audio: false,
            },
            picks: [],
            store: store,
            playHover: false,
            addHover: false,
            liked: false,
            likeHover: false,
        };
    },
    computed: {
        itemIsPast() {
            if (this.item.timezone == "0" || this.item.timezone == null) {
                return true;
            }
            let aware = DateTime.fromISO(this.item.start_time, {
                zone: this.item.timezone,
            });

            let utc = aware.toUTC();

            return utc.valueOf() < DateTime.utc().valueOf();
        },
        itemIsCurrentSeries() {
            if (this.item.all_series.length >= 1) {
                if (
                    this.item.series.some(
                        (s) => s.slug == this.item.all_series[0].slug
                    )
                ) {
                    if (this.itemIsPast) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (
                    this.item.series.some(
                        (s) => s.slug == this.item.all_series[1].slug
                    )
                ) {
                    if (
                        DateTime.fromISO(
                            this.item.all_series[0].earliest_item
                        ) < DateTime.now()
                    ) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        inPlaylist() {
            return this.store.playlist.items.some((e) => e.pk == this.item.pk);
        },
        getDate() {
            if (this.item.start_time) {
                if (this.item.has_audio) {
                    return DateTime.fromISO(this.item.start_time)
                        .setLocale("en-US")
                        .toFormat("MM/dd/yy");
                } else {
                    return DateTime.fromISO(this.item.start_time)
                        .setLocale("en-US")
                        .toLocaleString(DateTime.DATE_HUGE);
                }
            }
        },
        getTime() {
            if (this.item.start_time) {
                if (this.item.has_audio) {
                    //return Duration.fromObject({seconds:this.item.duration}).toFormat('hh:mm:ss')
                    return "";
                } else {
                    let aware = DateTime.fromISO(this.item.start_time, {
                        zone: this.item.timezone,
                    }).setLocale("en-US");
                    // console.log(aware.zoneName);
                    let local = aware.setZone("local");

                    if (aware.offset != local.offset) {
                        return `${local.toFormat(
                            "hh:mm"
                        )}&thinsp;${local.toFormat("a")}&ensp;(${aware.toFormat(
                            "hh:mm"
                        )}&thinsp;${aware.toFormat("a")}&ensp;${
                            this.item.city
                        })`;
                    } else {
                        return `${aware.toFormat(
                            "hh:mm"
                        )}&thinsp;${aware.toFormat("a")}`;
                    }
                    // return DateTime.fromISO(this.item.start_time)
                    //     .setLocale("en-US")
                    //     .toFormat("hh:mm a");
                }
            }
        },
    },
    methods: {
        addLike() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                myself.getCookie("csrftoken");
            axios
                .post("/api/add-like", {
                    pk: myself.item.pk,
                    user: myself.store.userID,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.liked = true;
                        myself.store.likes.push(response.data.like);
                        localStorage.setItem(
                            "likes",
                            JSON.stringify(myself.store.likes)
                        );
                        myself.liked = false;
                    }
                });
        },
        removeLike() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                myself.getCookie("csrftoken");
            axios
                .post("/api/remove-like", {
                    pk: myself.item.pk,
                    user: myself.store.userID,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.liked = false;
                        myself.store.likes = myself.store.likes.filter(
                            (l) => l != response.data.like
                        );
                        localStorage.setItem(
                            "likes",
                            JSON.stringify(myself.store.likes)
                        );
                    }
                });
        },
        isPlaying(pk, type) {
            if (
                store.privatePlayerItem.type == type &&
                store.privatePlayerItem.pk == pk &&
                store.privatePlayerStatus == "playing"
            ) {
                return true;
            }
        },
        upperFirst(tag) {
            return _.upperFirst(tag);
        },
        checkPick() {
            if (this.picks.includes(this.item.pk)) {
                return true;
            } else {
                return false;
            }
        },
        setPlay() {
            console.log("valid", this.store.valid);
            console.log("pick", this.checkPick());
            console.log("series", this.itemIsCurrentSeries);
            if (
                this.store.valid ||
                this.checkPick() ||
                this.itemIsCurrentSeries
            ) {
                this.store.privatePlayerItem = this.item;
                this.store.privatePlayerVisible = true;
                this.store.privatePlayerChanged = true;
                // this.store.privatePlayerStatus = "paused";
                this.store.privatePlayerStatus = "unpaused";
            } else {
                this.store.showSupportPopup = true;
            }
            //let myself = this;
            //setTimeout(function(){
            //myself.store.privatePlayerStatus = 'startplaying';
            //}, 1000)
        },
        setPause() {
            this.store.privatePlayerStatus = "paused";
            this.pauseHover = false;
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        addToList() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/add-task", {
                    //title: myself.item.title,
                    //artist: myself.item.artist,
                    //url: myself.item.audio,
                    //duration: myself.item.duration,
                    //thumbnail: myself.item.thumbnail,
                    //image: myself.item.image,
                    pk: myself.item.pk,
                    //category: myself.item.category,
                    //venue: myself.item.venue,
                    //city: myself.item.city,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.store.listFull = false;

                        axios.get("/api/get-tasks").then((response) => {
                            myself.store.playlist = response.data.playlist;
                            myself.store.streams = response.data.streams;
                        });
                    } else if (response.data.message == "listFull") {
                        myself.store.listFull = true;
                    }
                    myself.store.showAddPopup = true;
                });
        },
        selectTag(name) {
            this.store.selectedTags = [name];
            this.store.archiveTagChanged = true;
            this.$router.push({ name: "archive" });
        },
        selectSeries(series) {
            this.store.selectedSeries = [series];
            this.store.archiveTagChanged = true;
            this.store.seriesVisible = true;
            this.$router.push({ name: "archive" });
        },
    },

    mounted: function () {
        axios.get("/api/get-show/" + this.$route.params.id).then((response) => {
            this.item = response.data;
        });
        axios.get("/api/get-picks").then((response) => {
            this.picks = response.data.items.map((i) => i.pk);
        });

        window.scrollTo(0, 0);
    },
};
</script>

<style scoped>
#detail {
    margin: 1rem;
    max-width: 100%;
}

/* @media only screen and (min-width: 1101px) { */
/*     #detail { */
/*         max-width: 66%; */
/*     } */
/* } */
/* @media only screen and (min-width: 1440px) { */
/*     #detail { */
/*         max-width: 50%; */
/*     } */
/* } */
/* @media only screen and (min-width: 1900px) { */
/*     #detail { */
/*         max-width: 33%; */
/*     } */
/* } */
img#mainImage {
    width: 100%;
    aspect-ratio: 1 / 1;
    /* min-width: calc(100vw - 2rem); */
    /* min-height: calc(100vw - 2rem); */
    background-color: #d2d2d2;
}

#mainImage.LI {
    background-color: #8dd9fc;
}

#mainImage.IS {
    background-color: #f6b2c6;
}

#mainImage.IR {
    background-color: #f6b2c6;
}

#mainImage.RE {
    background-color: #9fe1a7;
}

#mainImage.NY {
    background-color: #fcfac4;
}

#mainImage.IN {
    background-color: #b0a4e4;
}

/* @media only screen and (min-width: 1101px) { */
/*     img { */
/*         min-width: 66vw; */
/*         max-width: 66vw; */
/*         min-height: 66vw; */
/*     } */
/* } */
/* @media only screen and (min-width: 1440px) { */
/*     img { */
/*         min-width: 50vw; */
/*         max-width: 50vw; */
/*         min-height: 50vw; */
/*     } */
/* } */
/* @media only screen and (min-width: 1900px) { */
/*     img { */
/*         min-width: 33vw; */
/*         max-width: 33vw; */
/*         min-height: 33vw; */
/*     } */
/* } */

.buttonImage,
.buttonSpacer {
    width: 1.8rem;
    min-width: unset;
    min-height: unset;
    background-color: transparent;
}

.buttonText {
    flex-grow: 1;
}

#location span:first-child {
}

#location span {
}

#location {
    /* margin-bottom: 0.7rem; */
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    gap: 1rem;
}

#location.live {
    font-size: initial;
    font-family: "Montez Large";
}

#location.desktop {
}

#time {
    margin-bottom: 1.4rem;
}

#date {
}

#date,
#time {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
}

.text,
#links {
    margin-bottom: 1.65rem;
}

.text >>> a {
    color: #aaaaaa;
}

#links .text {
    margin-bottom: 0;
}

#links a {
    color: #aaaaaa;
}

#links a:hover {
    color: black;
}

#audio {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.7rem;
}

@media only screen and (min-width: 738px) {
    #audio {
        flex-direction: row;
    }
}

#audio > div {
    border: 1px solid black;
    text-align: center;
    padding: 0.65rem 1rem 0.85rem;
    margin-bottom: 1rem;
}

#audio > div:last-of-type {
    margin-bottom: 0;
}

#audio > div:hover {
    background-color: black;
    color: white;
}

@media only screen and (min-width: 738px) {
    #audio > div {
        width: 50%;
        margin-left: 0.5rem;
        margin-bottom: 0;
    }

    #audio > div:first-child {
        margin-left: 0;
        margin-right: 1rem;
    }
}

#infos,
#liveInfos {
    display: flex;
    gap: 1rem;
    margin-top: 1.3rem;
    margin-bottom: 1.3rem;
    align-items: center;
}

#infos {
    margin-bottom: 0.65rem;
}

#liveInfos {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
}

#infos.mobile,
#liveInfos.mobile {
    margin-top: 0.4rem;
    /* margin-bottom: 0.2rem; */
}

#addText {
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
    align-self: center;
}

#dates {
    overflow: hidden;
    flex-grow: 1;
}

#dates > div {
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    overflow: hidden;
}

#firstBlock {
    display: flex;
    gap: 1rem;
    align-items: center;
}

img.button {
    height: 3rem;
    min-height: unset;
    min-width: unset;
    max-height: unset;
    max-width: unset;
    background-color: transparent;
}

img.button.add,
img.button.play.mobile {
    height: 1.7rem;
    align-self: flex-start;
}

img.button.add {
    cursor: pointer;
    align-self: center;
}

#play,
#add {
    cursor: pointer;
}

#tags {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.3rem;
}

.tag a {
    display: block;
    color: black;
    padding: 0rem 0.6rem;
    margin: 0rem;
    border: 1px solid black;
    border-radius: 2rem;
    font-size: 12px;
    font-family: "Montez Small";
    /* visibility: hidden; */
    cursor: pointer;
}

.tag a:hover {
    color: white;
    background-color: black;
}

.liveLocation {
    padding: 0rem 0.6rem;
    padding: 0px 0.6rem 2px;
    border: 1px solid black;
    border-radius: 2rem;
    font-size: 12px;
    font-family: "Montez Small";
    margin-top: 0.8rem !important;
}

#buttons {
    display: flex;
    gap: 4px;
    flex-direction: column;
}

@media only screen and (min-width: 738px) {
    #buttons {
        flex-direction: row;
    }
}
</style>
